import { ReactElement } from 'react';
import { omit } from 'lodash';
import { useRouter } from 'next/router';
import { Skeleton } from '@mui/material';

interface Props {
  richTitle: string | ReactElement;
  count?: number;
  isLoading?: boolean;
}

export const FilterTitle = ({ count, richTitle, isLoading = false }: Props) => {
  const router = useRouter();

  const shouldShowStats = () => !isLoading && !!count && !!Object.keys(omit(router.query, ['page', 'userType', 'sort', 'view'])).length;

  const renderTitle = () => {
    if (!shouldShowStats()) {
      return richTitle;
    }
    return (
      <>
        <span className="font-bold">{count?.toLocaleString()}</span>
        {' '}
        {richTitle}
      </>
    );
  };

  if (isLoading) {
    return <Skeleton variant="text" width="100%" height="32px" />;
  }
  return (
    <>
      <div className="flex flex-wrap items-center md:justify-between md:text-lg">
        <h1 className="w-full md:w-auto">{renderTitle()}</h1>
      </div>
    </>
  );
};
